import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCall = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M41.167 32a9.167 9.167 0 1 0-8.21-5.085c.162.326.216.7.122 1.052l-.546 2.04a1.192 1.192 0 0 0 1.46 1.46l2.04-.546c.352-.094.726-.04 1.052.123a9.1 9.1 0 0 0 4.082.956"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M48.958 22.833a7.792 7.792 0 1 0-14.77 3.468 2.9 2.9 0 0 1 .277 1.753l-.057.269-.464 1.731 1.733-.462.269-.057a2.9 2.9 0 0 1 1.753.277 7.792 7.792 0 0 0 11.26-6.979m2.75 0c0 5.822-4.72 10.542-10.541 10.542-1.684 0-3.28-.396-4.695-1.101a.2.2 0 0 0-.073-.023l-.01-.002-2.042.546c-1.907.51-3.652-1.234-3.142-3.142l.546-2.041q0 .008-.002-.01a.2.2 0 0 0-.023-.074 10.5 10.5 0 0 1-1.101-4.695c0-5.822 4.72-10.541 10.542-10.541s10.541 4.72 10.541 10.541"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="m24.736 23.413 1.19 2.132c1.073 1.924.642 4.448-1.049 6.14 0 0-2.051 2.05 1.668 5.77s5.77 1.668 5.77 1.668c1.692-1.691 4.216-2.122 6.14-1.048l2.132 1.19c2.905 1.62 3.249 5.695.695 8.25-1.535 1.534-3.415 2.728-5.493 2.806-3.498.133-9.439-.752-15.398-6.712-5.96-5.96-6.845-11.9-6.712-15.398.079-2.078 1.272-3.958 2.807-5.493 2.554-2.553 6.628-2.21 8.25.695"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M15.514 21.747c3.08-3.08 8.277-2.847 10.422.995l1.19 2.132c1.4 2.508.804 5.67-1.242 7.746q.008-.008.002 0a1 1 0 0 0-.06.093 1.24 1.24 0 0 0-.137.53c-.023.47.145 1.557 1.828 3.24s2.77 1.851 3.24 1.828a1.24 1.24 0 0 0 .53-.138 1 1 0 0 0 .094-.059c2.075-2.045 5.238-2.64 7.745-1.24l2.13 1.19c3.843 2.145 4.077 7.342.997 10.422-1.647 1.647-3.837 3.112-6.41 3.21-3.816.145-10.15-.842-16.424-7.115s-7.26-12.608-7.115-16.423c.098-2.574 1.563-4.764 3.21-6.411m8.021 2.336c-1.098-1.968-4.049-2.42-6.076-.392-1.422 1.422-2.347 2.99-2.407 4.573-.12 3.181.666 8.728 6.311 14.373 5.646 5.645 11.192 6.431 14.374 6.31 1.581-.06 3.15-.984 4.572-2.406 2.027-2.027 1.576-4.978-.392-6.076l-2.132-1.189c-1.327-.74-3.19-.488-4.498.82l-.972-.972c.972.972.97.974.97.974l-.012.012-.02.018q-.02.021-.05.047a3.442 3.442 0 0 1-.616.422 4 4 0 0 1-1.695.46c-1.486.073-3.284-.594-5.32-2.63-2.035-2.035-2.702-3.833-2.63-5.319a4 4 0 0 1 .46-1.695 3.4 3.4 0 0 1 .423-.616l.047-.05.018-.02.012-.012s.002-.002.741.737l-.739-.74c1.308-1.307 1.56-3.17.82-4.497z"
      />
    </svg>
  );
};
export default SvgCall;
